import { render, staticRenderFns } from "./agent-user-details.vue?vue&type=template&id=565ed7af&scoped=true&"
import script from "./agent-user-details.vue?vue&type=script&lang=js&"
export * from "./agent-user-details.vue?vue&type=script&lang=js&"
import style0 from "./agent-user-details.vue?vue&type=style&index=0&id=565ed7af&scoped=true&lang=css&"
import style1 from "./agent-user-details.vue?vue&type=style&index=1&id=565ed7af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ed7af",
  null
  
)

export default component.exports